import React, { useState, useRef, useEffect } from "react";
import { createProduct } from "../api/newprod";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import DateObject from "react-date-object";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import "../css/CreateForm.css";



const MAX_IMAGE_SIZE = 5 * 1024 * 1024;   // 5 MB
const MAX_VIDEO_SIZE = 50 * 1024 * 1024;  // 50 MB
dayjs.extend(utc);
dayjs.extend(jalaliday);

const ProductForm = ({ onSave, onCancel}) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    artist: "",
    price: "",
    category: "",
    material: "",
    style: "",
    feature_one: "",
    feature_two: "",
    length: "",
    width: "",
    height: "",
    weight: "",
    is_biddable: false,
    bidding_deadline: "",
    delivered_by: "",
    pickup_address: "",
    timezone: userTimezone,
  });
  
  const [images, setImages] = useState([]); 
  const [videos, setVideos] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [consoleError, setConsoleError] = useState("");
  const [categories, setCategories] = useState({});
  const [deliveryModesEn, setDeliveryModesEn] = useState({});
  const [deliveryModesFa, setDeliveryModesFa] = useState({});
  const [selectDeliveryMode, setDeliveryMode] = useState({});
  const [selectedSub, setSelectedSub] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const mediaInputRef = useRef(null);

  useEffect(() => {
    fetch("/data/DeliveryInfo.json")
      .then((res) => res.json())
      .then((data) => setDeliveryModesEn(data.DeliveryInformationEn))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);
  
  useEffect(() => {
    fetch("/data/DeliveryInfo.json")
      .then((res) => res.json())
      .then((data) => setDeliveryModesFa(data.DeliveryInformationFa))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);

  
  const normalizeNumber = (input) => {
    if (input == null || input === "") return "";

    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
    let str = String(input).trim();
    // Convert Persian/Arabic digits to English
    str = str.replace(/[۰-۹]/g, (d) => persianDigits.indexOf(d));
    str = str.replace(/[٠-٩]/g, (d) => arabicDigits.indexOf(d));
    // Remove spaces and Persian thousands separator
    str = str.replace(/[\s٬]/g, "");
    // Convert Arabic decimal separator to dot
    str = str.replace(/[٫/]/g, ".");
    const lastComma = str.lastIndexOf(",");
    const lastDot = str.lastIndexOf(".");

    if (lastComma > lastDot) {
      // European format: 1.234,56
      str = str.replace(/\./g, "");
      str = str.replace(",", ".");
    } else {
      // US format: 1,234.56
      str = str.replace(/,/g, "");
    }
    
    const num = Number(str);
    return Number.isNaN(num) ? null : num.toString();
  };

  const NUMERIC_FIELDS = ["length", "width", "price", "height", "weight" ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setSelectedCategory(e.target.value);
  };

  const handleDeliveryMode = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setDeliveryMode(e.target.value);
  };

  const handleCheckBox = (e) => {
    const { name, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    }
  };

  const handleMediaChange = (e) => {
    setError("");
    const files = Array.from(e.target.files || []);
    const newImages = [];
    const newVideos = [];

    for (const file of files) {
      if (!file.type) {
        newVideos.push(file);
        continue;
      }
      if (file.type.startsWith("image/")) {
        if (file.size > MAX_IMAGE_SIZE) {
          if (setlang === "en") {
          setError(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          alert(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          }
          continue;
        }
        newImages.push(file);
      } else if (file.type.startsWith("video/")) {
        if (file.size > MAX_VIDEO_SIZE) {
          if (setlang === "en") { 
          setError(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          alert(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
        }
          continue;
        }
        newVideos.push(file);
      } else {
        if (setlang === "en") { 
        setError((prev) => prev + ` Unsupported file type: ${file.name}.`);
        } else {
        setError((prev) => prev + ` فرمت فایل غیر قابل پردازش ${file.name}.`);
        }
      }
    }
    if (files.length > 5) {
      if (setlang === "en") {
        setError("You have exceeded maximum number of 5 files");
        alert("You have exceeded maximum number of 5 files");
      } else {
        setError("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نیست");
        alert("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نیست");
      }
    } else {
      setImages(newImages);
      setVideos(newVideos);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const data = new FormData();
    Object.entries(formData).forEach(([key, val]) => {
      const value = NUMERIC_FIELDS.includes(key)
        ? normalizeNumber(val)
        : val;

      data.append(key, value);
    });  

    images.forEach((file) => data.append("images", file));
    videos.forEach((file) => data.append("videos", file));

    try {
      await createProduct(data);
      onSave?.();
  
      setFormData({
        name: "",
        description: "",
        artist: "",
        price: "",
        category: "",
        material: "",
        style:"",
        feature_one: "",
        feature_two: "",
        length:"",
        width:"",
        height:"",
        weight:"",
        is_biddable: false,
        bidding_deadline: "",
        delivered_by: "",
        pickup_address: "",
        timezone: userTimezone,
      });
      setImages([]);
      setVideos([]);
      setError("");
      alert(setlang === "en"? "Post created successfully and will be published after verification.":"آگهی شما با موفقیت ثبت شد و پس از تایید در گالری منتشر می‌شود");

    } catch (err) {
      if (err.response?.data) {
        const data = err.response.data;
        if (typeof data === "object" && data !== null) {
          if (data.length) {
            if (lang==="fa") {
             setError("لطفا فقط از دو رقم اعشار برای طول استفاده کن، مانند ۱۲۴/۴۵ یا ۱۲۳.۴۵");
            } else {
              setError("Please check the value for length and use only two decimal point digits");
            }
          } else if (data.width) {
            if (lang==="fa") {
              setError("لطفا فقط از دو رقم اعشار برای عرض استفاده کن، مانند ۱۲۴/۴۵ یا ۱۲۳.۴۵");
            } else {
              setError("Please check the value for width and use only two decimal point digits");
            }
          } else if (data.height) {
            if (lang==="fa") {
              setError("لطفا فقط از دو رقم اعشار برای ارتفاع استفاده کن، مانند ۱۲۴/۴۵ یا ۱۲۳.۴۵");
            } else {
              setError("Please check the value for height and use only two decimal point digits");
            }
          } else {
            if (lang==="fa") {
              setError("مشکلی رخ داد، لطفا دوباره امتحان کن");
            } else {
              setError("An unexpected error occurred.");
            }
          }
        } else {
          if (lang==="fa") {
            setError("مشکلی رخ داد، لطفا دوباره امتحان کن");
          } else {
            setError("An unexpected error occurred.");
          }
        }
      } else {
        if (lang==="fa") {
          setError("مشکلی رخ داد، لطفا دوباره امتحان کن");
        } else {
          setError("An unexpected error occurred.");
        }
      }    

    } finally {
      setLoading(false);
    }
  };
  
  // Transation
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <div className="PFProdForm-container">
      <button onClick={onCancel} className="modal-close">
        &#10005;
      </button>
      <form onSubmit={handleSubmit} className={setlang === "en" ? "PFproduct-form" : "PFproduct-form-fa" }>
        
        {setlang === "en" ? 
        <h2>Create New Listing</h2>:
        <h2>آگهی جدید</h2>
        }

        {error && <p className="form-error">{error}</p>}

        {/* Grid-based inputs */}
        <input name="name" value={formData.name} onChange={handleChange} placeholder={setlang === "en" ? "Product's Name" : "نام محصول" } required />
        <input name="description" value={formData.description} onChange={handleChange} placeholder={setlang === "en" ? "Description" : "توضیحات" }/>
        <input name="artist" value={formData.artist} onChange={handleChange} placeholder={setlang === "en" ? "Artist" : "اثر هنرمند" } />
        <input name="price" type="decimal" value={formData.price} onChange={handleChange} placeholder={setlang === "en" ? "Requesting Price (IRT)" : "قیمت درخواستی (تومان)" } required />
        <input name="category" value={formData.category} onChange={handleChange} placeholder={setlang === "en" ? "category" : "دسته بندی"} />
        <input name="style" value={formData.style} onChange={handleChange} placeholder={setlang === "en" ? "style" : "استایل"} />
        <input name="material" value={formData.material} onChange={handleChange} placeholder={setlang === "en" ? "Material" : "جنس ساخت"} />
        <input name="feature_one" value={formData.feature_one} onChange={handleChange} placeholder={setlang === "en" ? "Special Features" : "ویژگی‌های خاص" } />
        <input name="feature_two" value={formData.feature_two} onChange={handleChange} placeholder={setlang === "en" ? "Basic Features" : "ویژگی‌های دیگر" } />
        <input name="length" value={formData.length} onChange={handleChange} placeholder={setlang === "en" ? "Length in cm" : "(cm) طول" } />
        <input name="width" value={formData.width} onChange={handleChange} placeholder={setlang === "en" ? "Width in cm": "(cm) عرض" }/>
        <input name="height" value={formData.height} onChange={handleChange} placeholder={setlang === "en" ? "Heigth in cm" : "(cm) ارتفاع" } />
        <input name="weight" value={formData.weight} onChange={handleChange} placeholder={setlang === "en" ? "Weigth in Kg": "(kg) وزن" } />


        {/* Media uploader (full width) */}
        <div className="media-upload">
          <label>
            {setlang === "en" ? "Choose Images & Videos" : "بارگذاری عکس و ویدیو " }
            <input
              ref={mediaInputRef}
              type="file"
              accept="image/*,video/*"
              multiple
              onChange={handleMediaChange}
            />
          </label>

          {/* Preview summary */}
          <div className="media-summary">
            {images.length > 0 && <div>{images.length} {setlang === "en" ? "image(s) selected" : "عکس" }</div>}
            {videos.length > 0 && <div>{videos.length} {setlang === "en" ? "video(s) selected" : "ویدیو" }</div>}
          </div>
        </div>

        {/* Checkbox & deadline 
        <div className="form-options">
          {setlang === "en" ?
          <label className="checkbox-inline">
            {setlang === "en" ? "Is Biddable?" : "قابل مزایده؟" }
            <input
              name="is_biddable"
              type="checkbox"
              checked={formData.is_biddable}
              onChange={handleCheckBox}
            />
          </label>
          :
          <label className="checkbox-inline">
            {setlang === "en" ? "Is Biddable?" : "قابل مزایده؟" }
            <input
              name="is_biddable"
              type="checkbox"
              checked={formData.is_biddable}
              onChange={handleCheckBox}
              />
          </label>
          }

          {formData.is_biddable && (
            <label className="deadline">
              {setlang === "en" ? "Bidding Deadline" : "تاریخ و زمان پایان مزایده" }
              <DatePicker
                calendar={persian}
                locale={setlang==="en"?persian_en:persian_fa}
                format="YYYY/MM/DD HH:mm"
                plugins={[ <TimePicker position="bottom" /> ]}
                value={formData.bidding_deadline ? new DateObject(new Date(formData.bidding_deadline)) : null}
                onChange={(dateObject) => {
                  if (!dateObject) return;

                  setFormData((prev) => ({
                    ...prev,
                    bidding_deadline: dateObject.toDate().toISOString(),
                  }));
                }}
              />
            </label>
          )}
          </div>
          */}
          
          <div className="delivered_by">
            {setlang === "en" ?
              <select name="delivered_by" value={formData.delivered_by} onChange={handleDeliveryMode} className="narrow_select" placeholder="Delivered by:" >
                <option value=""> "-- Select Delivery Mode --"</option>
                {Object.keys(deliveryModesEn).map((cat, idx) => (
                  <option key={idx} value={cat}> {cat} </option> ))}
              </select>
              :
              <select name="delivered_by" value={formData.delivered_by} onChange={handleDeliveryMode} className="narrow_select" placeholder="Delivered by:" >
                <option value="">"-- شیوه ارسال  --"</option>
                {Object.keys(deliveryModesFa).map((cat, idx) => (
                  <option key={idx} value={cat}> {cat} </option> ))}
              </select>
            }
          
            {setlang === "en" ? (
              formData.delivered_by!=="Post" && (
                <label >
                <p>Provide Delivery Details: </p>
                  <input
                    name="pickup_address"
                    value={formData.pickup_address}
                    onChange={handleChange}
                  />
                </label>
            )
            ):(
              formData.delivered_by!=="پست" && (
                <label>
                <p>روش ارسال محصول به خریدار</p>
                  <input
                    name="pickup_address"
                    value={formData.pickup_address}
                    onChange={handleChange}
                  />
                </label>
            ))}
          </div>

        <div className="form-button-container">
          <button className="" type="button" onClick={onCancel}>{setlang === "en" ? "Cancel" : "لغو" }</button>
          <button type="submit" disabled={loading}>{setlang === "en" ? "Create Product" : "انتشار آگهی" }</button>
        </div>

        {loading && (
          <div className="loading-overlay">
            <div className="loading-box" style={{ '--spinner-size': '60px' }}>
              <div className="spinner" />
              <span>{setlang === "en" ? 'Loading...':'... در حال بارگذاری'}</span>
            </div>
          </div>
        )}
        
      </form>
    </div>

  );
};

export default ProductForm;
